'use client';

import Script from 'next/script';

const MicrosoftClarity = () => {
  return (
    <>
      {}
      <Script
        id="microsoft-clarity-init"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
                    (function(c,l,a,r,i,t,y){
                        if (typeof window === 'undefined') return;
                        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                        y=l.getElementsByTagName(r)[0];
                        if (y && y.parentNode) {
                            y.parentNode.insertBefore(t,y);
                        }
                    })(window, document, "clarity", "script", "kn4pi0cbzm");
                    `,
        }}
      />
    </>
  );
};

export default MicrosoftClarity;
